import { Controller } from "stimulus";
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";

export default class extends Controller {
  static targets = [
    'inputDate',
    'form'
  ];

  connect() {
    AjaxLoader.hide();
    this.initDatePickerInline();
    this.adjustCalendar();

    $('.submit-form').on('change', (ev) => this.submitForm(ev));

    document.querySelectorAll('.toggle-filter').forEach(($el) => {
      if (!$el.dataset.listeningEvent)
        $el.addEventListener('click', (ev) => { this.toggleFilter() } )
      $el.dataset.listeningEvent = true;
    });

    this.element.querySelectorAll('a.date').forEach(($a) => {
      $a.addEventListener('click', (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        this.inputDateTarget.value = $a.dataset.date;
        this.submitForm();
      });
    });
  }

  initDatePickerInline() {
    let $dateAttendance = this.element.querySelector('input.input-date-attendance');
    flatpickr($dateAttendance, {
      appendTo: $dateAttendance.parentElement,
      locale: Portuguese,
      onChange: (selectedDates) => {
        this.inputDateTarget.value = flatpickr.formatDate(selectedDates[0], 'Y-m-d');
        this.submitForm();
      }
    });

    $('.flatpickr-open').on('click', () => $dateAttendance._flatpickr.open());
  }

  submitForm() {
    AjaxLoader.show();
    this.formTarget.insertAdjacentHTML('afterBegin', '<button id="submit-button" class="d-none"></button>');
    this.formTarget.querySelector('#submit-button').click();
  }

  toggleFilter() {
    this.element.querySelector('.filters').classList.toggle('in')
  }

  adjustCalendar() {
    if (window.matchMedia("(max-width: 576px)").matches) {
      return;
    }

    let panelScroll = this.element.querySelector('.filters');

    panelScroll.style.height = `calc(100vh - ${panelScroll.getBoundingClientRect().y + 2}px - ${document.querySelector('.tr-footer').clientHeight}px)`;

    $(panelScroll).on('scroll', (ev) => {
      panelScroll.closest('.side-panel-container').classList.toggle('scrolled', panelScroll.scrollTop > 0);
    });
  }
}